import type { Course } from "@/types/course";
import { CourseCard } from "./CourseCard";
import { CoursesLoadingSkeleton } from "./CoursesLoadingSkeleton";

interface CoursesListProps {
	courses: Course[];
	isLoading: boolean;
}

export const CoursesList = ({ courses, isLoading }: CoursesListProps) => {
	if (isLoading) {
		return <CoursesLoadingSkeleton />;
	}

	if (courses.length === 0) {
		return (
			<div className="text-center py-12">
				<p className="text-muted-foreground">
					Nenhum curso disponível no momento.
				</p>
			</div>
		);
	}

	const orderedCourses = [...courses].sort(
		(firstCourse, secondCourse) =>
			(firstCourse.displayOrder ?? Number.MAX_SAFE_INTEGER) -
			(secondCourse.displayOrder ?? Number.MAX_SAFE_INTEGER),
	);

	return (
		<div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
			{orderedCourses.map((course, index) => (
				<CourseCard key={course.id} course={course} animationIndex={index} />
			))}
		</div>
	);
};
